import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Star, Quote, User } from 'lucide-react';
import ServicesModal from '../Body/ServicesModal/ServicesModal';
import './Testimonios.css';

const Testimonios = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const testimonials = [
    {
      name: "María García",
      role: "Perdió 15kg en 6 meses",
      text: "El acompañamiento de la Dra. Martell fue fundamental en mi proceso. Sus planes son realmente personalizados y su apoyo constante me ayudó a mantenerme motivada.",
      rating: 5
    },
    {
      name: "Carlos Rodriguez",
      role: "Deportista amateur",
      text: "Gracias a la asesoría nutricional, mejoré significativamente mi rendimiento deportivo. Los planes se adaptan perfectamente a mis entrenamientos.",
      rating: 5
    },
    {
      name: "Ana Torres",
      role: "Mamá primeriza",
      text: "Encontré el equilibrio perfecto entre una alimentación saludable y mi nueva vida como madre. Los consejos prácticos fueron invaluables.",
      rating: 5
    }
  ];

  return (
    <div className="testimonios-container">
      <div className="testimonios-content">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="testimonios-header"
        >
          <h2 className="testimonios-main-title">
            <span className="title-dark">Testimonios</span>{' '}
            <span className="title-yellow">Destacados</span>
          </h2>
          <p className="testimonios-subtitle">
            Lo que dicen nuestros pacientes sobre su
            <span className="highlight"> transformación</span>
          </p>
        </motion.div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 * index }}
              whileHover={{ scale: 1.03 }}
              className="testimonial-card"
            >
              <Quote className="quote-icon" />
              <div className="rating">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="star-icon" fill="#FFCB00" color="#FFCB00" />
                ))}
              </div>
              <p className="testimonial-text">{testimonial.text}</p>
              <div className="testimonial-author">
                <div className="author-image">
                  <User className="user-icon" />
                </div>
                <div className="author-info">
                  <h4 className="author-name">{testimonial.name}</h4>
                  <p className="author-role">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8 }}
          className="cta-section"
        >
          <h3 className="cta-title">¿Listo para comenzar tu transformación?</h3>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="cta-button"
            onClick={handleOpenModal}
          >
            Agenda tu consulta ahora
          </motion.button>
        </motion.div>
      </div>

      {/* Services Modal */}
      {isModalOpen && (
        <ServicesModal 
          isOpen={isModalOpen} 
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

export default Testimonios;